"use strict";

export function draw_images_slider(data) {



	let qty_images = 0;
	$('#my-gallery').html('');
	// Iterate over each image item in the data array
	Object.keys(data).forEach(email_id => {
		const emailData = data[email_id];
		// Create a container for each email_id
		const emailContainer = $(`<div class="email-container" id="email-${email_id}"></div>`);
		$('#my-gallery').append(`<h2>Email #${email_id}</h2>`);

		// Iterate over each file_id in the emailData object
		Object.keys(emailData).forEach(file_id => {
			const fileData = emailData[file_id];

			// Create a container for each file_id to group its images
			const fileContainer = $(`<div class="file-container" id="file-${file_id}"></div>`);
			emailContainer.append(`<h3>File #${file_id}</h3>`);
			let page_number = 1;
			// Iterate over each image item in the fileData array
			fileData.forEach(item => {
				qty_images++;
				// Append each image to the fileContainer as a thumbnail with 150px height
				fileContainer.append(
					` 
		               <a
		                	class="imageWrap"
		                   href="${item.path}" 
		                   target="_blank"
		                   data-pswp-width="${item.width}" 
		                   data-pswp-height="${item.height}"
		               >
		                   <img src="${item.path}" alt="Image" style="height: 150px; width: auto;">
		                   <span class="pageTitle">Page #${page_number}</span>
		               </a>		 
		            `
				);
				page_number++;
			});

			emailContainer.append(fileContainer);
		});

		// Append the emailContainer to the gallery
		$('#my-gallery').append(emailContainer);
	});
	$('.qty_images').html('[' + qty_images + ']');

	// import('https://unpkg.com/photoswipe/dist/photoswipe-lightbox.esm.js')
	// 	.then(({default: PhotoSwipeLightbox}) => {
	// 		// Initialize PhotoSwipeLightbox
	// 		const lightbox = new PhotoSwipeLightbox({
	// 			gallery: '#my-gallery',
	// 			children: 'a',
	// 			pswpModule: () => import('https://unpkg.com/photoswipe'),
	// 			getThumbBoundsFn: (index) => {
	// 				// Optional: Calculate thumbnail bounds for opening animation
	// 				const thumbnail = document.querySelectorAll('#my-gallery img')[index];
	// 				const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
	// 				const rect = thumbnail.getBoundingClientRect();
	//
	// 				return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
	// 			},
	// 		});
	//
	// 		lightbox.init();
	// 	});

}
